import { DROPDOWN_SEARCH_ELEMENT, DROPDOWN_SEARCH_FIELD_KEY } from '../finders/finder.component';
import ViewsExposed from '../views.exposed';
import debounce from 'lodash.debounce';

const FUND_LIST_ROOT_KEY = '#fundListWrapper';
const ACCORDION_BLOCK_KEY = "div[id^='fund-accordion-id-block']";

const FUND_ITEM = '.fund-list__accordion';
const SHOW_ALL_KEY = '.fund-list__show-all';
const COLLAPSE_LINK_KEY = '[data-bs-toggle="collapse"]';

const SEARCH_INPUT_ROOT_KEY = '.fund-list__search';
const SEARCH_INPUT_FIELD_KEY = '.fund-list__search-field';

export default class FundsPage {
  static get searchField() {
    return jQuery(SEARCH_INPUT_ROOT_KEY).find(SEARCH_INPUT_FIELD_KEY);
  }

  static get dropdownSearchField() {
    return jQuery(DROPDOWN_SEARCH_ELEMENT).find(DROPDOWN_SEARCH_FIELD_KEY);
  }

  static get fundList() {
    return jQuery(ACCORDION_BLOCK_KEY);
  }

  static searchSyncHandler() {
    FundsPage.searchField.val(FundsPage.dropdownSearchField.val());
  }

  init() {
    FundsPage.dropdownSearchField.on('input', FundsPage.searchSyncHandler);
    FundsPage.initCollapsible();
    FundsPage.handleRowClick();
    FundsPage.initBrowserNavigationHandler();
  }

  static initCollapsible() {
    const debouncedCollapseCheckHandler = debounce((e) => {
      FundsPage.collapseCheckHandler(FundsPage.getWrapper(e.target));
    }, 10);

    jQuery('.block--filtered-funds-block')
      .on('show.bs.collapse hide.bs.collapse', ACCORDION_BLOCK_KEY, debouncedCollapseCheckHandler)
      .on('click', SHOW_ALL_KEY, FundsPage.showAllHandler);
  }

  static getWrapper(target) {
    return jQuery(target).closest(FUND_LIST_ROOT_KEY);
  }

  static collapseCheckHandler(wrapper) {
    const action = FundsPage.getCollapseAllAction(wrapper);
    wrapper.find(SHOW_ALL_KEY).attr('aria-expanded', action === 'hide' ? 'true' : 'false');
  }

  static showAllHandler(e) {
    const wrapper = FundsPage.getWrapper(e.target);
    const action = FundsPage.getCollapseAllAction(wrapper);
    wrapper.find(COLLAPSE_LINK_KEY).each((i, el) => {
      jQuery(el).attr('aria-expanded', action === 'show' ? 'true' : 'false');
      jQuery(FUND_ITEM).eq(i).find('.collapse').removeClass('show hide').addClass(action);
    });
    wrapper.find(SHOW_ALL_KEY).attr('aria-expanded', action === 'show' ? 'true' : 'false');
  }

  static getCollapseAllAction(wrapper) {
    const hasOneClosed = wrapper
      .find(COLLAPSE_LINK_KEY)
      .toArray()
      .some((el) => {
        return (el.getAttribute('aria-expanded') || 'false') === 'false';
      });

    return hasOneClosed ? 'show' : 'hide';
  }

  static handleRowClick() {
    this.registerRowClickHandler();

    (function () {
      Drupal.behaviors.fundsPageHandleRowClick = {
        attach() {
          FundsPage.registerRowClickHandler();
        },
      };
    })(jQuery);
  }

  static registerRowClickHandler() {
    jQuery('.clickable-row').on('click', function () {
      window.location = `${window.location.origin}${jQuery(this).attr('link')}`;
    });
  }

  static initBrowserNavigationHandler() {
    window.addEventListener('popstate', () => {
      if (window.location.search === ViewsExposed.locationSearch) {
        return;
      }

      const filters = jQuery('[data-fund-list-filter]').find('select');

      filters.each(function () {
        const filter = jQuery(this);
        const name = filter.attr('name');
        const queryValue = decodeURI((getQueryParam(name) || '').replace(/\+/g, ' '));

        filter.val(queryValue);
      });

      filters.first().trigger('change');
    });
  }
}

export const getQueryParam = (key) => {
  const results = new RegExp(`[\?&]${key}=([^&#]*)`).exec(window.location.search);

  return results ? results[1] : null;
};
